export const heightRowTable = import.meta.env.VITE_IS_PRODUCTION === 'true' ? 35 : 24
export const heightRowHeaderTable = import.meta.env.VITE_IS_PRODUCTION === 'true' ? 24 : 20

export const fontSizeTable = 12
